// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index__wrapper___11OV5","box":"index__box___9AMLu","disabled":"index__disabled___3yuf3"};